var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-container"},[_c('div',{staticClass:"centered-item"},[(_vm.size!=='sm')?_c('img',{attrs:{"src":require("../assets/spinner/spinner.gif"),"alt":""}}):_c('img',{attrs:{"src":require("../assets/spinner/spinner_sm.gif"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }